import { createFileRoute } from "@tanstack/react-router";

import { AccountSettingsPanel } from "../components/settings/AccountSettings";

function SettingsAccountRoute() {
  return <AccountSettingsPanel />;
}

export const Route = createFileRoute("/settings/account")({
  component: SettingsAccountRoute,
});
